<template>
  <div class="page login">
    <Header @clickHome="clickHome" />

    <div class="loginFormBox">
      <!-- ID/PWD 입력부 -->
      <LoginForm @onClickSignIn="loginAction" />

      <!-- 회원가입 -->
      <JoinButtons />

      <MiddleUI @changeCheck="changeCheck" :userData="userData" />

      <CommonDialog ref="refCommonDialog" @clickOk="clickPopupOk" />
    </div>

    <Footer />
  </div>
</template>

<script>
import { safeReturnTo } from "@/utils/cardnews";
import { mapActions, mapState } from "vuex";
import Header from "./comp/Header.vue";
import Footer from "../commonComp/Footer.vue";
import MiddleUI from "./comp/MiddleUI.vue";
import JoinButtons from "./comp/JoinButton.vue";
import LoginForm from "./comp/LoginForm.vue";
import Cookies from "js-cookie";
const modelService = require("@/utils/dataModel.js");
import CommonDialog from "@/_zplabZPT/commonComp/dialog/CommonDialog.vue";

export default {
  components: {
    Header,
    Footer,
    MiddleUI,
    JoinButtons,
    LoginForm,
    CommonDialog,
  },
  data() {
    return {
      pwShow: false,
      userData: modelService.userModel(),
      isChecked: false,
      isActionMode: ""
    };
  },
  methods: {
    changeCheck(e) {
      this.isChecked = e;
    },
    clickHome() {
      this.$router.push({ path: "/home" }).catch(() => {});
    },
    loginAction(e) {
      e.userAgent = navigator.userAgent.toLowerCase();
      this.signIn(e).then((res) => {
        if (res === undefined) return;

        // 아이디 비번을 틀린 경우
        let msg = "등록되지 않은 아이디(휴대폰 번호) 이거나 비밀번호를 잘못 입력하셨습니다. <br/>아이디 또는 비밀번호를 다시 입력해 주세요."
        if (res === 401) {
          this.isActionMode = "loginError";
          this.$refs.refCommonDialog.open(msg);
          return;
        }

        // 계정 승인 전
        if (res.approved !== "Y") {
          this.isActionMode = "loginError"
          if(res.approved === "P") this.$refs.refCommonDialog.open("회원가입 인증 대기중입니다. <br/> 관리자의 승인 후 서비스 이용이 가능합니다.");
          else if(res.approved === "N") this.$refs.refCommonDialog.open("회원가입 승인이 거절되어 서비스를 이용할 수 없습니다.");
          else this.$refs.refCommonDialog.open("회원가입 승인 여부를 확인할 수 없습니다.<br/>관리자에게 문의하세요.");
          return;
        }

        if (res.mrCode === "DEFAULT") {
          this.isActionMode = "DEFAULT"
          this.$refs.refCommonDialog.open("비밀번호 변경페이지로 이동합니다");
          return;
        }

        // 로그인 성공후 로그인 아이디 기억하기
        if (this.isChecked) {
          Cookies.set("zplabSaveLoginId", e.loginId, {expires: 100000});
        } else {
          Cookies.set("zplabSaveLoginId", "");
        }

        // 카드뉴스 링크로 들어왔다가 로그인으로 튕긴 경우 원래 자리로 돌려보낸다.
        // 카드뉴스는 메뉴에 없어 직접 링크로만 접근하므로, 홈으로 보내면 다시 찾아갈 방법이 없다.
        const back = safeReturnTo(this.$route.query.returnTo);

        // 리로드
        window.location.href = back || "/home";
      });
    },
    clickPopupOk() {
      if (this.isActionMode === "DEFAULT") {
        window.location.href = "/tempChangePassword";
      }
    },
    ...mapActions(["signIn", "saveDataPreLoginQuery"]),
  },
  computed: {
    ...mapState(["loginCheck"]),
  },
};
</script>

<style lang="scss">
.login {
  .loginFormBox {
    padding: 20px;
    position: relative;
    z-index: 100;
  }
  .v-btn.btn-kakao {
    background: #f6d523;
    color: #000000;
  }

  .link-group {
    padding: 0 0 0 10px;
    text-align: right;
    margin: 10px auto 0 !important;
    width: 90vw;
    max-width: 100%;
    justify-content: space-between;
    align-items: flex-start;
    .v-input--checkbox {
      margin-top: 0;
      padding-top: 0;
    }
    .v-label {
      font-size: 12px;
    }
    .v-btn {
      // text-decoration: underline;
      font-weight: 400;
      color: #333333;
      font-size: 12px;
    }
  }
}
</style>
